import { render, staticRenderFns } from "./Overdue.vue?vue&type=template&id=2e429f3a&scoped=true&"
import script from "./Overdue.vue?vue&type=script&async=true&lang=js&"
export * from "./Overdue.vue?vue&type=script&async=true&lang=js&"
import style0 from "./Overdue.vue?vue&type=style&index=0&id=2e429f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e429f3a",
  null
  
)

export default component.exports